

















import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { fetchNewslist } from '@/api/api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class Home extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  onLoad() {
    fetchNewslist(this.page, 9672).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
}
